import React from "react";
import '../styles/leftsidebar.css';
import { showToast } from "../helpers/UIHelper";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const LeftSideBar = (props) => {
    const Auth = useAuth();
    const navigate = useNavigate();
    const copyLink = async () => {
        const link = window.location.origin;
        try {
            // Try using the Clipboard API
            await navigator.clipboard.writeText(link);
            showToast('info', 'Link copied to clipboard!');
        } catch (err) {
            // Fallback for older browsers or unsupported environments
            const textarea = document.createElement("textarea");
            textarea.value = link;
            textarea.style.position = "fixed";
            textarea.style.opacity = 0;
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            
            try {
                document.execCommand('copy'); 
                showToast('info', 'Link copied to clipboard!');
            } catch (err) {
                showToast('error', 'Failed to copy link.');
            }
            
            document.body.removeChild(textarea); // Cleanup
        }
    }
    const logout = () => {
        Auth.userLogout();
    }
    return (
        <div className={props.show ? "side-bar show-sidebar" : "side-bar"}>
            <div className="sidebar-head">
                <i className="las la-angle-right" onClick={props.onClose}/>
            </div>
            <div className="links">
                <div className="link" onClick={copyLink}>
                    <i className="las la-share-square" />
                    <div>
                        Share
                    </div>
                </div>
                <div className="link" onClick={() => { navigate('/terms') }}>
                    <i className="las la-file-pdf" />
                    <div>
                        Terms And Conditions
                    </div>
                </div>
                <div className="link" onClick={() => { navigate('/policies'); }}>
                    <i className="las la-file-alt" />
                    <div>
                        Applicable Policies
                    </div>
                </div>
                <div className="link" onClick={()=>{navigate('/about')}}>
                    <i className="las la-info-circle" />
                    <div>
                        About
                    </div>
                </div>
                <div className="link" onClick={() => { navigate('/') }}>
                    <i className="las la-home" />
                    <div>
                        Home
                    </div>
                </div>
                <div className="link warn-bg" onClick={logout}>
                    <i className="las la-sign-in-alt" />
                    <div>
                        Sign Out
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LeftSideBar;